import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import React from 'react';
import './App.css';
import Landing from './containers/Landing/Landing';
import Login from './containers/Login/Login';
import Upload from './containers/Upload/Upload';
import PhotoGuide from './containers/PhotoGuide/PhotoGuide';
import './site.css';
import './styles.min.css';
import {
  BrowserRouter,
  Switch,
  Route
} from "react-router-dom";
import 'blueimp-canvas-to-blob/js/canvas-to-blob';
import { withMsalLoginApi } from './msalConfig';
import AzureLogin from './containers/AzureLogin/AzureLogin';
import Result from './component/Result/Result';
import NotFound from './component/ErrorModal/NotFound';
import PhotoGuideline from './component/PhotoGuideline/PhotoGuideline.js';
import {BasicTable} from './component/PhotoGuideline/BasicTable.js';

function guidelines()
{
    return(
       <div>
           <BasicTable/>
        </div>
    )
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* <Headers user={userid} /> */}
        <Switch>
          <Route path="/Login" exact component={Login} />
          <Route path="/Upload" exact component={Upload} />
          <Route path="/PhotoGuide" exact component={PhotoGuide} />
          <Route path="/AzureLogin" exact component={AzureLogin} />
          <Route path="/Result" exact component={Result} />
          <Route path="/" exact component={Landing} />
          <Route path="*" component={NotFound} />
          <Route path="/Guidelines" exact component={PhotoGuideline}/>
        </Switch>
      </div>

    </BrowserRouter>
  );
}

export default App; 
//export default guidelines
